import { Alert } from '@mantine/core';
import React from 'react';
import IconAlertError from '../../icons/IconAlertError';
import IconAlertWarning from '../../icons/IconAlertWarning';
import PropTypes from 'prop-types';
import { IconCheckCircle } from '../../icons/IconCheckCircle';
import styles from './styles.scoped.css';
import IconInfoFull from '../../icons/IconInfoFull';

const AlertInfo = ({ type = 'error', children }, ...props) => {
  const colorMap = {
    borderColor: {
      error: '#CF212A',
      warning: '#FF711A',
      success: '#44AB4A',
    },
    bg: {
      error: '#FFFAFA',
      warning: '#FFFCF5',
      success: '#F0FFF1',
      info: '#F5FAFF'
    },
    icon: {
      error: <IconAlertError />,
      warning: <IconAlertWarning />,
      success: <IconCheckCircle className={styles.iconCheck} />,
      info: <IconInfoFull className={styles.iconInfo} />,
    },
  };
  return (
    <Alert
      {...props}
      icon={colorMap.icon[type]}
      radius={8}
      styles={{
        root: {
          border: colorMap.borderColor[type] ? `1px solid ${colorMap.borderColor[type]}`: 'none',
          backgroundColor: colorMap.bg[type],
          color: '#25282B',
          borderLeftWidth: '4px !important',
        },
        wrapper: {
          alignItems: 'center',
        },
        title: {
          color: '#25282B',
          margin: '0',
          fontWeight: 600,
          fontSize: 16,
        },
      }}
    >{children}
    </Alert>
  );
};

export default AlertInfo;

AlertInfo.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['error', 'warning']),
};
